"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Chat = function (_a) {
    var pageId = _a.pageId, minimized = _a.minimized, color = _a.color;
    var container = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (typeof window !== "undefined" && container.current) {
            container.current.setAttribute("page_id", pageId);
            container.current.setAttribute("attribution", "biz_inbox");
            if (color)
                container.current.setAttribute("theme_color", color);
            if (minimized)
                container.current.setAttribute("minimized", minimized.toString());
        }
    }, [container, pageId, color, minimized]);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { ref: container, id: "fb-customer-chat", className: "fb-customerchat" })));
};
exports["default"] = Chat;
//# sourceMappingURL=Chat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tusken-s/facebook-tools/dist/cjs/components/Chat.js
// module id = 218
// module chunks = 168707334958949